export default "__VITE_ASSET__q4txqyHT__"